export const translations = {
	'Are you sure you want to delete dashboard?': {
		no: 'Vil du slette dashboard?',
	},
	'Are you sure you want to delete {0} dashboards?': {
		no: 'Vil du slette {0} dashboardene?',
	},
	'Not able to import dashboard. There might be an issue with the file.': {
		no: 'Klarte ikke Ã¥ importere dashboard. Det kan vÃ¦re noe feil med filen.',
	},
	'Dashboard was successfully imported.': {
		no: 'Dashboard ble importert.',
	},
	'Click to copy public/private dashboard link': {
		no: 'Klikk for Ã¥ kopiere offentlig/private dashboard lenken',
		en: 'Click to copy public/private dashboard link',
	},
	'Set as public': {
		no: 'Sett som felles',
	},
	'Set as private': {
		no: 'Sett som privat',
	},
	Duplicate: {
		no: 'Duplikat',
	},
	Mobile: {
		no: 'Mobil',
	},
	Link: {
		no: 'Link',
	},
	Access: {
		no: 'Tilgang',
	},
	Updated: {
		no: 'oppdatert',
	},
	'Link is copied': {
		no: 'Lenken er kopiert',
	},
	'Public mode: Viewable by anyone with the link': {
		no: 'Offentlig modus: Kan vises av alle som har lenken',
	},
	'Private mode: Requires login to access': {
		no: 'Privat modus: Krever innlogging for tilgang',
	},
};
